// extracted by mini-css-extract-plugin
module.exports = {"button":"LanguageChanger_button__1nKN9","languageLabel":"LanguageChanger_language-label__ko1HX","content":"LanguageChanger_content__Uby_C","form":"LanguageChanger_form__e0F70"};